import { Grid, Typography } from '@mui/material';
import { theme } from 'theme';

const styles = {
  container: {
    textAlign: 'center',
    minHeight: '100vh',
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(12),
    backgroundColor: theme.palette.common.white,
  },
};

export const NotFound = () => (
  <Grid component="main" sx={styles.container}>
    <Typography variant="h1">PAGE NOT FOUND</Typography>
  </Grid>
);
